// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__ZgR9i","contentWrap":"styles_contentWrap__OYrAn","cardsWrap":"styles_cardsWrap__ZzYZo"};